import { MetricTypes, SurvivalHorizonData, AccountFlow, ThroughputData } from '@liquitics/transaction';
import { TrendMetric } from './../trend-metric/trend-metric';
export class SuspenseBalanceMetric extends TrendMetric {
    balance: number;
    payBalance: number;
    recBalance: number;
    breakDownTop10: {
        'currency': string,
        'account': string,
        'tradeDateTime': string,
        'client': string,
        'amount': number,
        'externalRef': string,
        'flowKey': string,
        'eventDateTime': string,
        'direction': string,
    }[];
    breakDownLast10: {
        'currency': string,
        'account': string,
        'tradeDateTime': string,
        'client': string,
        'amount': number,
        'externalRef': string,
        'flowKey': string,
        'eventDateTime': string,
        'direction': string,
    }[];
    constructor() {
        super(MetricTypes.SUSPENSE_BALANCE, 'suspense-balance');
    }

}
